export const DASHBOARD_WELCOME_TOUR_STORAGE_KEY =
  "tk_dashboard_welcome_tour_v1";

const SEEN_VALUE = "1";

export function markDashboardWelcomeTourSeen(): void {
  try {
    localStorage.setItem(DASHBOARD_WELCOME_TOUR_STORAGE_KEY, SEEN_VALUE);
  } catch {
    /* private browsing / blocked storage */
  }
}

export function hasDashboardWelcomeTourBeenSeen(): boolean {
  try {
    return (
      localStorage.getItem(DASHBOARD_WELCOME_TOUR_STORAGE_KEY) === SEEN_VALUE
    );
  } catch {
    return true;
  }
}
